"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextLinesLimitWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.TextLinesLimitWrapper = styled_components_1.default.div `
    div {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: ${({ maxLines }) => maxLines};
        -webkit-box-orient: vertical;
    }
`;
